import { useEffect, useState } from "react";
import { analyticsApi } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Tooltip } from "recharts";

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  const [board, setBoard] = useState([]);
  useEffect(() => {
    analyticsApi.admin().then(setData);
    analyticsApi.leaderboard("coins").then(setBoard);
  }, []);

  return (
    <div data-testid="admin-analytics-page" className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Insights</div>
        <h1 className="font-display font-bold text-3xl tracking-tight mt-1">Analytics</h1>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="en-card p-6">
          <h3 className="font-display font-semibold text-lg mb-4">Subject performance</h3>
          <div className="h-72">
            <ResponsiveContainer>
              <BarChart data={data?.subject_avg || []}>
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
                <XAxis dataKey="subject" tick={{ fill: "hsl(var(--muted-foreground))" }} />
                <YAxis tick={{ fill: "hsl(var(--muted-foreground))" }} />
                <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 12 }} />
                <Bar dataKey="avg_score" fill="hsl(var(--secondary))" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <Card className="en-card p-6">
          <h3 className="font-display font-semibold text-lg mb-4">Leaderboard</h3>
          <div className="space-y-2">
            {board.map((b, i) => (
              <div key={b.user.id} className="flex items-center justify-between p-3 rounded-xl bg-muted/40">
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 rounded-lg grid place-items-center bg-primary/10 text-primary font-display font-bold text-sm">#{i+1}</div>
                  <div>
                    <div className="font-medium text-sm">{b.user.name}</div>
                    <div className="text-xs text-muted-foreground">{b.user.exam_target}</div>
                  </div>
                </div>
                <Badge variant="secondary" className="rounded-full">{b.count} pts</Badge>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
